import type { InsightGroup } from "@v2/features/infra/analytics/events";
import type { Insight } from "schemas/generated/insights";

import { exhaustiveSwitch } from "replo-utils/lib/misc";

export function isInsightBuildableInReplo(insight: Insight) {
  const isReploPage = Boolean(insight.projectId) && Boolean(insight.elementId);

  return isReploPage && insight.actionType === "buildInEditor";
}

/**
 * The group that we're returning is one of the groups that we show on the analytics insight
 * page and that the user can filter by.
 *
 * @author Max 2025-04-23
 */
export function getInsightGroup(insight: Insight): InsightGroup {
  if (isInsightBuildableInReplo(insight)) {
    return "build-in-replo";
  }

  return exhaustiveSwitch({ type: insight.sentiment })({
    positive: "trending-up",
    negative: "trending-down",
    neutral: "other",
  });
}
